'use client';

import { ExternalLink } from 'lucide-react';
import { useTranslations } from 'next-intl';
import SectionHeading from '@/components/ui/SectionHeading';
import SmartImage from '@/components/ui/SmartImage';

interface ResortCardsProps {
  heading?: boolean;
  className?: string;
}

export default function ResortCards({ heading = true, className }: ResortCardsProps) {
  const t = useTranslations('ResortCards');

  const resortCards = [
    {
      name: 'Ylläs',
      tagline: t('yllasTagline'),
      link: 'https://www.yllas.fi/en/',
      image: '/images/resorts/yllas-resort.jpg',
    },
    {
      name: 'Levi',
      tagline: t('leviTagline'),
      link: 'https://www.levi.fi/en/',
      image: '/images/resorts/levi-resort.jpg',
    },
  ];

  return (
    <div className={className}>
      {heading && (
        <SectionHeading
          title={t('title')}
          subtitle={t('subtitle')}
          className="mb-10"
        />
      )}
      <div className="grid md:grid-cols-2 gap-6">
        {resortCards.map((resort) => (
          <a
            key={resort.name}
            href={resort.link}
            target="_blank"
            rel="noopener noreferrer"
            className="group relative block rounded-xl overflow-hidden aspect-[3/2]"
          >
            <SmartImage
              src={resort.image}
              alt={resort.name}
              category="resort"
              width={1200}
              height={800}
              fill
              className="transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6 transition-transform duration-300 group-hover:-translate-y-1">
              <h3 className="font-sans text-2xl md:text-3xl font-light text-white mb-1">
                {resort.name}
              </h3>
              <p className="text-white/80 text-sm md:text-base mb-3">
                {resort.tagline}
              </p>
              <span className="inline-flex items-center gap-1.5 text-[#C4A95E] text-sm font-medium">
                {t('visitSite')}
                <ExternalLink className="w-4 h-4" />
              </span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
